import { render, staticRenderFns } from "./fieldTrialInfo.vue?vue&type=template&id=6dbc9d94&scoped=true"
import script from "./fieldTrialInfo.vue?vue&type=script&lang=js"
export * from "./fieldTrialInfo.vue?vue&type=script&lang=js"
import style0 from "./fieldTrialInfo.vue?vue&type=style&index=0&id=6dbc9d94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbc9d94",
  null
  
)

export default component.exports